import React from "react";
import { Typography } from "@mui/material";
import { WHATSAPP_URL } from "../../utils/contact";

const WhatsAppLink: React.FC = () => (
  <Typography>
    <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
      WhatsApp: 320 603 7344
    </a>
  </Typography>
);

export default WhatsAppLink;
